import {
  OAUTH_SET_RANDOM_STATE,
  OAUTH_SET_DATA,
  OAUTH_LOGOUT_SUCCESS,
  OAUTH_LOGOUT_FAILURE,
  OAUTH_TOKEN_FAILURE,
  OAUTH_SET_NOTIFICATION_PERMISSION,
  OAUTH_TOKEN_REFRESH_FAILURE,
} from "../../actions/oauth";

import { decodeAuthErrorResponse } from "../../utils/oauth";

export const initialState = {
  tokenKey: "",
  authData: {},
  username: null,
  clientId: null,
  error: null,
  authState: "",
  loggedIn: false,
  rights: [],
  errorLogout: "No Message",
  notificationPermission: undefined,
  tokenError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OAUTH_SET_RANDOM_STATE:
      return {
        ...state,
        authState: action.authState,
      };
    case OAUTH_SET_DATA:
      return {
        ...state,
        loggedIn: true,
        authData: action.authData,
        username: action.username,
        clientId: action.clientId,
        rights: action.rights,
      };
    case OAUTH_LOGOUT_FAILURE:
      return {
        ...state,
        errorLogout: action.message || "Couldn't logout",
      };
    case OAUTH_TOKEN_FAILURE:
      return {
        ...state,
        loggedIn: false,
        error: decodeAuthErrorResponse(action.payload.response.error, action.payload.response.error_description),
      };
    case OAUTH_SET_NOTIFICATION_PERMISSION:
      return {
        ...state,
        notificationPermission: action.notificationPermission,
      };
    case OAUTH_LOGOUT_SUCCESS:
      window.location.reload();
      return { ...state };
    case OAUTH_TOKEN_REFRESH_FAILURE:
      // eslint-disable-next-line no-new
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("rights");
      setTimeout(() => window.location.reload(), 10000);
      return { ...state, tokenError: true };
    default:
      return state;
  }
};
